/** Result codes Drop-in reports through `onPaymentCompleted` / `onPaymentFailed`. */
export const ADYEN_RESULT_CODE = {
  AUTHORISED: 'Authorised',
  PENDING: 'Pending',
  RECEIVED: 'Received',
  CANCELLED: 'Cancelled',
} as const;
